import { IconSearch } from "@tabler/icons-react"

export default function SearchPage() {
  return (
    <div className="flex flex-col gap-4 py-4 md:gap-6 md:py-6 px-4 lg:px-6">
      <div className="flex items-center gap-2">
        <IconSearch className="size-6" />
        <h1 className="text-2xl font-bold">Search</h1>
      </div>
      <p className="text-muted-foreground">
        Search across applications, clients, and records.
      </p>
      <div className="max-w-xl">
        <input
          type="text"
          placeholder="Search by name, application ID, or keyword..."
          className="w-full rounded-lg border bg-background px-4 py-2.5 text-sm outline-none focus:ring-2 focus:ring-ring"
        />
      </div>
    </div>
  )
}
